import React from 'react'
import "./bsproducts.css"
import { useNavigate } from 'react-router-dom';

function BSProducts({id, data}: any) {
  const navigate = useNavigate();
  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="bs-prod-thumbnail">
            <img className='bs-prod-img' src={data?.img.data[0].attributes.url} alt="" />
            <div className="bs-text-content">
              <p className="bs-name">{data?.title}</p>
              <p className="bs-price">&#8377;{data?.price}</p>
            </div>
          </div>
        </div>
        <div className="flip-card-back">
          <div className="bs-back-details" id='bs-back-details'>
            <p className='bs-detail' >Company: Redgear</p>
            <p className='bs-detail' >Category: Headphones</p>
            <p className='bs-detail' >Company: Redgear</p>
            <p className='bs-detail' >Category: Headphones</p>
            <p className='bs-detail' >Company: Redgear</p>
            <p className='bs-detail' >Category: Headphones</p>
            <div className="bs-vp-btn">
              <button className="bs-btn" onClick={() => navigate("/product/" + id)}>VIEW ITEM</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BSProducts
